"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _inputComponent = _interopRequireDefault(require("../input-component"));

var _numberInputComponent = _interopRequireDefault(require("../number-input-component"));

var _selectComponent = _interopRequireDefault(require("../select-component"));

var _cta = _interopRequireDefault(require("../cta"));

var _elements = require("../glyphs/elements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  actions: (0, _propTypes.objectOf)(_propTypes.string),
  categoryOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),
  initialState: (0, _propTypes.shape)({
    category: _propTypes.string,
    categoryError: _propTypes.bool,
    check: _propTypes.bool,
    date: _propTypes.string,
    dateError: _propTypes.bool,
    email: _propTypes.string,
    emailError: _propTypes.bool,
    password: _propTypes.string,
    passwordError: _propTypes.bool,
    radio: _propTypes.string,
    success: _propTypes.bool,
    time: _propTypes.number,
    toggle: _propTypes.bool
  }),
  reducer: _propTypes.func,
  submitForm: _propTypes.func,
  timeOptions: (0, _propTypes.arrayOf)(_propTypes.string),
  updateField: _propTypes.func
};

var Form = function Form(_ref) {
  var actions = _ref.actions,
      categoryOptions = _ref.categoryOptions,
      initialState = _ref.initialState,
      reducer = _ref.reducer,
      submitForm = _ref.submitForm,
      timeOptions = _ref.timeOptions,
      updateField = _ref.updateField;

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var incTime = (0, _react.useCallback)(function () {
    return dispatch({
      type: actions.INC_TIME
    });
  }, [actions.INC_TIME]);
  var decTime = (0, _react.useCallback)(function () {
    return dispatch({
      type: actions.DEC_TIME
    });
  }, [actions.DEC_TIME]);
  var setCategory = (0, _react.useCallback)(updateField("category", dispatch), [dispatch]);
  var setEmail = (0, _react.useCallback)(updateField("email", dispatch), [dispatch]);
  var setPassword = (0, _react.useCallback)(updateField("password", dispatch), [dispatch]);
  var submit = submitForm(state, dispatch);
  var currTime = timeOptions[state.time];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    ml: 2,
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_inputComponent["default"], {
    error: state.emailError,
    label: "Email",
    onChange: setEmail,
    placeholder: "example@qualcomm.com",
    required: true,
    type: "email",
    value: state.email
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    ml: 2,
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_inputComponent["default"], {
    error: state.passwordError,
    label: "Password",
    onChange: setPassword,
    placeholder: "",
    required: true,
    type: "password",
    value: state.password
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: ["column", "row"],
    m: 2
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_numberInputComponent["default"], {
    onDownClick: decTime,
    onUpClick: incTime,
    options: timeOptions,
    value: currTime
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    ml: [0, 1],
    mt: [2, 0]
  }, /*#__PURE__*/_react["default"].createElement(_selectComponent["default"], {
    error: state.categoryError,
    label: "Category",
    onChange: setCategory,
    options: categoryOptions,
    placholder: "Category X",
    value: state.category
  }))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    ml: 2,
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    glyphRight: state.success ? /*#__PURE__*/_react["default"].createElement(_elements.NavCheck, null) : /*#__PURE__*/_react["default"].createElement(_elements.NavCaretRight, null),
    onClick: submit,
    version: "secondary"
  }, state.success ? "Success" : "Submit")));
};

Form.propTypes = propTypes;
Form.displayName = "Modules.Form";
var _default = Form;
exports["default"] = _default;